import Tasks from 'APP/Tasks';
import { UpdateReason } from 'APP/constants/scroll';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export async function addMyFakeNewMessages(
  groupId: string,
  messages: ChatMessage[] = []
): Promise<void> {
  if (groupId !== Entities.GroupsStore.activeGroupId || messages.length === 0) {
    return;
  }

  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }
  group.messagesStore.unfocusMessage();

  const prevMessageTs = group.messagesStore.isLoadedLastMessages
    ? group.messagesStore.lastMessage?.serverTime
    : group.lastMessage?.serverTime;

  let expectedServerTime = prevMessageTs ? prevMessageTs : Date.now();
  let serverTime = expectedServerTime;

  messages.forEach((message) => message.setMessageTime(++expectedServerTime, ++serverTime));

  Tasks.messaging.updateOldOrFakeMessages({ messages, groupId, prevMessageTs });
  group.messagesStore.setNewMessagesPlaceholderTs(0);
  group.counter!.setSeenTs(serverTime);

  Entities.ChatStore.setScrollChanged(UpdateReason.ScrollToBottom, { isAnimated: true });
}
